import momentZ from 'moment-timezone';
import {createRequest} from '../utils/HttpRequestUtills';

export const SET_IS_LOADING_APPS_WITH_RANKS = 'SET_IS_LOADING_APPS_WITH_RANKS';
export const SAVE_APPS_WITH_RANKS = 'SAVE_APPS_WITH_RANKS';

export const getAppsWithRanks = (
    fromDate = new Date(),
    toDate = new Date(),
) => (dispatch, getState) => {
  dispatch({
    type: SET_IS_LOADING_APPS_WITH_RANKS,
    isLoading: true,
  });

  const stateId = getState().ranks.stateId;

  const fromDateString = momentZ(fromDate).subtract(3, 'days').utc().format('YYYY-MM-DD');
  const toDateString = momentZ(toDate).utc().format('YYYY-MM-DD');

  const onload = (responseText) => {
    const response = JSON.parse(responseText);
    const timeStampRequest = momentZ().format('x');

    dispatch({
      type: SAVE_APPS_WITH_RANKS,
      requestTimeEpoch: timeStampRequest,
      stateId,
      apps: response,
    });
  };
  const xhr = createRequest(dispatch, 'GET', `/metrics/apps-ranks?fromDate=${fromDateString}&toDate=${toDateString}`, onload);

  xhr.send();
};
